var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VForm',{staticClass:"form-search",on:{"request":_vm.onSubmit}},[_c('VInput',{attrs:{"placeholder":_vm.placeholder,"name":"search","type":"search","width":"460px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }